module.exports = __webpack_public_path__ + "static/media/1709330876712.ee9c4a20.jpg";